(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initTermsValidation = void 0;
var CLASS_ERROR = 'has-error';
var markError = function markError(container, hasError) {
  container.classList.toggle(CLASS_ERROR, hasError);
};
var validateAll = function validateAll(checkboxes) {
  var valid = true;
  checkboxes.forEach(function (cb) {
    var container = cb.closest('.login-page__term-check');
    var unchecked = !cb.checked;
    if (container) {
      markError(container, unchecked);
    }
    if (unchecked) {
      valid = false;
    }
  });
  return valid;
};
var initTermsValidation = exports.initTermsValidation = function initTermsValidation() {
  var form = document.querySelector('.login-page__form');
  if (!form) return;
  var checkboxes = Array.from(form.querySelectorAll('input[data-terms-required]'));
  if (!checkboxes.length) return;
  form.addEventListener('submit', function (e) {
    if (!validateAll(checkboxes)) {
      e.preventDefault();
      var firstError = form.querySelector('.login-page__term-check.has-error');
      if (firstError) {
        firstError.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  });
  checkboxes.forEach(function (cb) {
    cb.addEventListener('change', function () {
      var container = cb.closest('.login-page__term-check');
      if (container) {
        markError(container, !cb.checked);
      }
    });
  });
};

},{}],2:[function(require,module,exports){
"use strict";

var _termsValidation = require("./app/myaccount/termsValidation");
document.addEventListener('DOMContentLoaded', _termsValidation.initTermsValidation);

},{"./app/myaccount/termsValidation":1}]},{},[2]);
